import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonDirective } from 'primeng/button';
import type { Notification } from '../core/services/notification';

@Component({
  selector: 'app-notification-list',
  imports: [TranslateModule, ButtonDirective],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="flex justify-between items-center gap-2 border-b border-hairline pb-3 mb-2">
      <span class="font-black text-ink text-sm">Notifications</span>
      <button type="button" pButton [text]="true" size="small"
        label="Marquer tout comme lu" severity="secondary" (click)="readAll.emit()"></button>
    </div>
    @if (notifications().length === 0) {
      <div class="py-8 text-center text-ink-muted">
        <i class="pi pi-bell-slash text-2xl block mb-2 opacity-40" aria-hidden="true"></i>
        <p class="text-sm">{{ 'LAYOUT.NO_NOTIFICATION' | translate }}</p>
      </div>
    }
    @for (notification of notifications(); track notification.id ?? $index) {
      <button type="button" class="flex w-full items-start gap-3 py-3 px-2 rounded-lg text-left hover:bg-chrome transition-colors border-b border-hairline last:border-0"
        (click)="activate.emit(notification)">
        @switch (notification.type) {
          @case ('error') {
            <i class="pi pi-times-circle text-danger-text text-base mt-0.5 shrink-0" aria-hidden="true"></i>
          }
          @case ('warning') {
            <i class="pi pi-exclamation-circle text-warning-text text-base mt-0.5 shrink-0" aria-hidden="true"></i>
          }
          @case ('success') {
            <i class="pi pi-check-circle text-success-text text-base mt-0.5 shrink-0" aria-hidden="true"></i>
          }
          @default {
            <i class="pi pi-info-circle text-info-text text-base mt-0.5 shrink-0" aria-hidden="true"></i>
          }
        }
        <span class="flex-1 min-w-0 flex flex-col gap-0.5">
          <span class="font-bold text-sm text-ink leading-tight">{{ notification.title }}</span>
          <span class="text-xs text-ink-muted leading-snug">{{ notification.message }}</span>
        </span>
        @if (!notification.read) {
          <span class="w-2 h-2 rounded-full bg-info-base shrink-0 mt-1.5" aria-hidden="true"></span>
          <span class="sr-only">Non lue</span>
        }
      </button>
    }
  `,
})
export class NotificationListComponent {
  readonly notifications = input.required<readonly Notification[]>();
  readonly activate = output<Notification>();
  readonly readAll = output<void>();
}
